export const APIEndpoints = {
  FetchVendorsList: '/v0/service/vendor/list',
  ValidateThirdPartyVendorToken:
    '/v0/rag/workflows/multi_file_va/vendor/validate-token',
  SendThirdPartyVendorFormEmail:
    '/v0/rag/workflows/multi_file_va/vendor/send-email',
  SubmitThirdPartyVendorForm:
    '/v0/rag/workflows/multi_file_va/vendor/intake-form',  // Fixed missing leading slash
  EvidenceCollectionAuth:
    '/v0/tpra/vendor/authenticate',
  EvidenceUpload:
    '/v0/tpra/evidences/upload',
  PatchEvidence:
    '/v0/tpra/evidences',
  SubmitQuestionnaire:
    '/v0/tpra/questionnaire/submit',
  SubmitQuestionnaireForm:
    '/v0/tpra/questionnaires/submit',
  UpdateIndividualQuestion:
    '/v0/tpra/questionnaires/question/{question_id}',
  RespondOffline:
    '/v0/tpra/questionnaires/respond-offline',
  VendorSessionQuestionnaire:
    '/v0/tpra/questionnaires/vendor-session-questionnaire',
  ChatMessages:
    '/v0/tpra/chat/messages',
  MarkQuestionnaireCompleted:
    '/v0/tpra/questionnaires/mark-completed',
};
